/**
 * Прилипшая полоска записи «● Запись 0:47 · Стоп» (решение владельца §5.3).
 *
 * 🔴 ЗАЧЕМ ВНЕШНИЙ СТОР. Полоска живёт поверх всей страницы, а блок записи лежит
 * глубоко внутри списка заданий, и таких блоков в разделе бывает несколько. Тем
 * же приёмом уже сделано предупреждение об уходе со страницы
 * (`lib/recordingGuard.ts`), и заводить второй способ ради одного и того же было
 * бы лишним.
 *
 * ⚠️ ЧАСЫ И УРОВЕНЬ — ФУНКЦИИ, А НЕ ЧИСЛА. Полоска спрашивает их в кадре
 * отрисовки: копия числа устарела бы через двадцатую долю секунды, а подписка на
 * каждое изменение уровня означала бы шестьдесят перерисовок страницы урока в
 * секунду — на телефоне это заметное подтормаживание.
 *
 * ⚠️ ЗАПИСЬ ОДНА. Вторая гасит первую: до сих пор ничто не мешало запустить две
 * сразу — два микрофона, двое часов и одна полоска на двоих.
 */

export type BarSession = {
  blockId: string;
  /** Подпись задания, если её стоит показать рядом. */
  title?: string;
  elapsedMs(): number;
  /** Уровень звука 0…1; где измерителя нет — всегда 0. */
  level(): number;
  state(): 'recording' | 'paused';
  /** Та же остановка, что у кнопки в задании. */
  stop(): void;
  /** Эту запись погасила другая — прибраться за собой. */
  onPreempt?: () => void;
};

let current: BarSession | null = null;
const listeners = new Set<() => void>();

const emit = () => listeners.forEach((l) => l());

export function startBar(session: BarSession): () => void {
  if (current && current !== session) current.onPreempt?.();
  current = session;
  emit();
  return () => {
    // ⚠️ Гасим ТОЛЬКО свою полоску: первая запись может закончиться уже после
    // того, как началась вторая, и её «конец» не должен убирать чужую.
    if (current !== session) return;
    current = null;
    emit();
  };
}

export function barSession(): BarSession | null {
  return current;
}

export function subscribeBar(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Только для проверок. */
export function resetBarForTests(): void {
  current = null;
  listeners.clear();
}
